import { Component, ElementRef, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ContentElement, ContentElementEnum } from '../../models/sections-model';

@Component({
  selector: 'kw-content-element-renderer',
  templateUrl: './content-element-renderer.component.html',
  styleUrls: ['./content-element-renderer.component.scss']
})
export class ContentElementRendererComponent implements OnInit,OnChanges {
  @Input() contentElements:ContentElement[];
  @Input() contentName:string;
  @Input() preview:boolean;
  isIcon:boolean;
  @Input() contentElement:ContentElement;

  contentElementEnum:ContentElementEnum;

  previewEl:HTMLElement;
  inputEl:HTMLElement;
  displayEl:HTMLElement;

  containerPadding:string;
  classes:string;
  containerClasses:string;

  @Output() updatedContent:EventEmitter<ContentElement> = new EventEmitter<ContentElement>()
  @ViewChild('headerInput',{read:ElementRef}) headerInput:ElementRef;

  widthClasses = ["kve-fullwidth","kve-autoWidth"]

  /* @HostBinding("style.--content-element-text-color") color:string;
  @HostBinding("style.--content-element-font-family") fontFamily:string;
  @HostBinding("style.--content-element-background") background:string;
  @HostBinding("style.--content-element-font-weight") fontWeight:string;
  @HostBinding("style.--content-border-color") borderColor:string; */

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes:SimpleChanges):void{
/*     if(changes["contentName"]){
      console.log(this.contentName);
    } */
    if(changes["contentElement"] && this.contentElement != undefined){
      console.log(this.preview)
      console.log(this.contentElement.contentElementEnum);
      if(this.contentElement.elId == "HERO_1_CNT_1_1"){
        console.log(this.contentElement)
      }
      if(this.contentElement.parentBorder != undefined){
        console.log(this.contentElement.parentBorder);
      }else{
        console.log("No parent border defined")
      }
      /* if(this.contentElement.contentElementEnum == undefined){
        console.log(this.contentElement)
      } */
      /* if(typeof this.contentElement.contentElementEnum === "string"){
        switch (this.contentElement.contentElementEnum.toString()) {
          case "ContentElementEnum.HEADER":
            this.contentElement
          case "ContentElementEnum.HEADER":
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:
          case ContentElementEnum.HEADER:  
            
            break;
        
          default:
            break;
        }
      }else{
        this.contentElementEnum = this.contentElement.contentElementEnum?this.contentElement.contentElementEnum:ContentElementEnum.TEXT;
      } */
      this.contentElementEnum = this.getContentElementEnumValue(this.contentElement);
      //this.contentElementEnum = this.contentElement.contentElementEnum?this.contentElement.contentElementEnum:ContentElementEnum.TEXT;
      if(this.contentElement.classes == undefined || this.contentElement.classes == null) {
        this.contentElement["classes"] = [];
      }
      //Add default classes
      if(!this.contentElement.classes.includes("kve-fullwidth") && !this.contentElement.classes.includes("kve-autoWidth")){
        this.contentElement["classes"].push("kve-fullwidth");
        if(!this.contentElement.classes.includes("justify-right") && !this.contentElement.classes.includes("justify-center") && !this.contentElement.classes.includes("justify-center")){
          this.contentElement["classes"].push("justify-left");
        }
      }
      if(!this.contentElement.classes.includes("kve-border")){
        this.contentElement["classes"].push("kve-border");
      }
      if(this.contentElement["classes"].length > 0){
        this.classes = this.arrayToStringAndRemoveCommas(this.contentElement["classes"]);
        //console.log(this.classes)
      }
      //Default Container classes
      if(this.contentElement.containerClasses == undefined || this.contentElement.containerClasses == null) {
        this.contentElement["containerClasses"] = [];
      }
      if(this.contentElement.isLink != undefined && this.contentElement.isLink){
        this.contentElement["containerClasses"].push("link-container");
      }else{
        this.contentElement["containerClasses"].push("non-link");
      }
      //Add container alignment class
      if(!this.contentElement.containerClasses.includes("container-align-top") && !this.contentElement.containerClasses.includes("container-align-center") && !this.contentElement.containerClasses.includes("container-align-bottom")){
        this.contentElement["containerClasses"].push("container-align-top");
      }

      if(this.contentElement.containerClasses.length > 0){
        this.containerClasses = this.arrayToStringAndRemoveCommas(this.contentElement.containerClasses);
        console.log(this.containerClasses);
      }
      /* if(this.contentElement.color != undefined){
        this.color = this.contentElement.color
      }
      if(this.contentElement.fontFamily != undefined){
        this.fontFamily = this.contentElement.fontFamily
      }
      if(this.contentElement.background != undefined){
        this.background = this.contentElement.background
      }
      if(this.contentElement.fontWeight != undefined){
        this.fontWeight = this.contentElement.fontWeight;
      }
      if(this.contentElement.borderColor != undefined){
        this.borderColor = this.contentElement.borderColor;
      } */
      //console.log(this.contentElement["classes"].toString());
    }
  }

  setCssVariables(contentElement:ContentElement){
    if(contentElement.borderColor != undefined){

    }
  }

  onResolved(contentElement){
    this.contentElement = contentElement;
    //console.log(this.contentElement);
    /* if(this.contentElement.isLink != undefined){
      this.contentElement.isLink = this.convertToBoolean(this.contentElement.isLink);
    } */
    if(this.contentElement.iconClass != undefined && this.contentElement.iconClass != null){
      this.isIcon = true;
    }else{
      this.isIcon = false;
    }
    if(this.contentElement.fontFamily == undefined){
      this.contentElement.fontFamily = "Open Sans, sans-serif"
    }
  }

  onMouseEnter(hoverContentEl:HTMLElement){
    if(this.preview){
      this.previewEl = hoverContentEl.querySelector('.preview-selected');
      this.displayEl = hoverContentEl.querySelector(".content-element");
      this.inputEl = hoverContentEl.querySelector("input");
      if(this.previewEl && this.previewEl.classList.contains('hide')){
        this.previewEl.classList.toggle('hide');
        this.previewEl.classList.toggle('show');
      }
    }
  }

  onMouseOut(hoverContentEl:HTMLElement){
    if(this.preview){
      if(this.previewEl && this.previewEl.classList.contains('show')){
        this.previewEl.classList.toggle('show');
        //inputEl.blur();
      }
      if(this.previewEl && !this.previewEl.classList.contains('hide')){
        this.previewEl.classList.toggle('hide');
      }
      if(this.inputEl && this.inputEl.classList.contains('show')){
        this.inputEl.classList.toggle('show');
        this.inputEl.classList.toggle('hide');
      }
      if(this.displayEl && this.displayEl.classList.contains('hide')){
        //inputEl.classList.toggle('show');
        this.displayEl.classList.toggle('hide');
      }
    }
  }

  onClick(hoverContentEl:HTMLElement){
    console.log(hoverContentEl);
    if(this.preview){
      this.displayEl.focus();
    }
    /* if(this.preview){
      if(this.inputEl && this.inputEl.classList.contains('hide')){
        this.inputEl.classList.toggle('show');
        this.inputEl.classList.toggle('hide');
        this.displayEl.classList.toggle('hide');
        this.inputEl.focus();
      }
      if(this.previewEl && this.previewEl.classList.contains('show')){
        this.previewEl.classList.toggle("show")
      }
    } */

    
  }

  onBlur(e){
    if(this.preview){
      console.log(this.displayEl.innerText);
      this.contentElement.text = this.displayEl.innerText;
      this.updatedContent.emit(this.contentElement);

      /* if(this.previewEl && this.previewEl.classList.contains('show')){
        this.previewEl.classList.toggle("show");
        this.previewEl.classList.toggle("hide");
      }
      this.contentElement.text = e.target.value;
      this.updatedContent.emit(this.contentElement); */
    }
  }

  onChangeContentEl(name,value){
    console.log(value);
    this.contentElement.text = value;
    /* let targetEl = this.contentElements.find(contEl => contEl.name == name);
    targetEl.text = value; */
    
  }

  arrayToStringAndRemoveCommas(inputArray: string[]): string {
    // Remove commas from each element of the array
    const cleanedArray = inputArray.map(element => element.replace(/,/g, ''));

    // Join the cleaned array elements into a single string with spaces (or any other delimiter)
    const resultString = cleanedArray.join(' ');

    return resultString;
}



  convertToBoolean(value:any){
    switch(value){
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
          return true;
      default: 
          return false;
    }
  }

  getContentElementEnumValue(cntEl:ContentElement){
    let cntElEnum;
    if(cntEl.contentElementEnum){
      console.log(cntEl.contentElementEnum);

      if((cntEl.contentElementEnum).includes(".")){
        console.log("Enum has dot",cntEl.contentElementEnum);
        let enumKey = cntEl.contentElementEnum.split('.')[1] as keyof typeof ContentElementEnum;
        cntElEnum = ContentElementEnum[enumKey];
      }else{
        cntElEnum = ContentElementEnum[cntEl.contentElementEnum]
      }

    }else{
      if(cntEl.name != undefined){
        switch (cntEl.name) {
          case "Header":
            cntElEnum = "header";
            cntEl.contentElementEnum = ContentElementEnum.HEADER;                      
            break;
          case "Description":
            cntElEnum = "text"; 
            break;
          case "Email":
            cntElEnum = "text";
            break;
          case "Text":
            cntElEnum = "text";
            break;
          case "Footer":
            cntElEnum = "footer";
            break;
          case "Badge":
            cntElEnum = "badge"            
            break;
        
          default:
            break;
        }        
      }
      console.log(cntEl);
    }
    console.log(cntElEnum?cntElEnum:cntEl.contentElementEnum);
    return cntElEnum;
  }

}
